<div class="notification border-bottom">
  <div class="container notification__content d-flex align-items-start">
    <crnt-icon class="me-2 lh-base" icon="circle-exclamation" size="medium" />
    <div *wlGenericRichText="message()" role="status"></div>
  </div>
</div>
